// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2y_zX","description":"PatientConsentPreview_description__2WWYj"};